import { NavbarMenu } from '@root/core/interfaces';

export const ADMIN_WAREHOUSE_API_MENU: NavbarMenu[] = [
  {
    id: 1,
    name: 'Quotataion',
    url: '/admin/warehouse-api/quotation'
  },
  {
    id: 2,
    name: 'Import',
    url: '/admin/warehouse-api/import'
  },
  {
    id: 3,
    name: 'Inventory',
    url: '/admin/warehouse-api/inventory'
  },
  {
    id: 1,
    label: 'Order',
    children: [
      { name: 'return', url: '/admin/warehouse-api/order/return' },
      { name: 'normal', url: '/admin/warehouse-api/order/normal' }
    ]
  }
];
